import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { animateScroll } from 'react-scroll';
import moment from 'moment';
import i18n from 'utils/translate';
import NavigationButtons from 'components/NavigationButtons';
import PaymentConfirmation from 'components/PaymentConfirmation';
import Section from 'components/Section';
import ConfirmationField from 'components/ConfirmationField';
import { formatPrice } from 'utils/common';
import loader from '../../../../../images/loader-big.gif';
import './styles.scss';
import { linkTypeShape } from 'utils/types';

const propTypes = {
  onChange: PropTypes.func.isRequired,
  backLink: PropTypes.shape(linkTypeShape).isRequired
};

const defaultProps = { data: {} };

class Summary extends Component {
  constructor(props) {
    super(props);

    this.state = {
      validForm: false,
      submitted: false,
      ...props.data
    };
  }

  componentDidMount() {
    animateScroll.scrollToTop({ duration: 0 });
  }

  render() {
    const { backLink, onConfirm, payment_type, iban, bic, apiErrorMessages, paymentPending, loading } = this.props;
    const { submitted, validForm, downloadedContract, ...data } = this.state;
    const paymentProps = { type: payment_type, iban, bic };

    if (paymentPending) {
      return (
        <div className="payment-summary loader-wrapper">
          <img src={loader} alt="loader" />
        </div>
      );
    }

    return (
      <div className="page-step-wrapper summary" id="payment-summary">
        <form ref="form" className={`page-step-wrapper page-step-wrapper--narrow ${submitted ? 'submitted' : ''}`}>
          <Section header={i18n('Zahlungsdaten')}>
            <ConfirmationField halfWidth={true} title={i18n('Contract type')}>
              {data.type === 'initial' ? `${i18n('Initial')}` : `${i18n('Continous')}`}
            </ConfirmationField>
            <ConfirmationField halfWidth={true} title={i18n('Payment type')}>
              {data.currency === 'EUR' ? `${i18n('EUR')}` : `${i18n('HUF')}`}
            </ConfirmationField>
            <ConfirmationField halfWidth={true} title={i18n('Name')}>
              {data.firstname} {data.lastname}
            </ConfirmationField>
            <ConfirmationField halfWidth={true} title={i18n('Date of birth')}>
              {moment(data.birthdate).format('DD.MM.YYYY')}
            </ConfirmationField>
            <ConfirmationField halfWidth={true} title={i18n('E-Mail')}>
              {data.email}
            </ConfirmationField>
            {data.offer && (
              <>
                <ConfirmationField halfWidth={true} title={i18n('Offer number')}>
                  {data.offer}
                </ConfirmationField>
              </>
            )}
            {data.contract && (
              <>
                <ConfirmationField halfWidth={true} title={i18n('Contract number')}>
                  {data.contract}
                </ConfirmationField>
              </>
            )}
            <ConfirmationField halfWidth={true} title={i18n('Prämie')}>
              {formatPrice(data.premium, data.currency)}
            </ConfirmationField>
          </Section>
          <Section header={i18n('Bezahlung')}>
            <PaymentConfirmation halfWidth={true} {...paymentProps} />
            {apiErrorMessages &&
              apiErrorMessages.length > 0 &&
              apiErrorMessages.map((error, index) => (
                <span className="error-message col-xs-12" key={`error-${index}`}>
                  <span className="error-icon" />
                  {error.validierungsText}
                </span>
              ))}
          </Section>

          <NavigationButtons
            backLink={backLink}
            canContinue={data.tos}
            nextText={i18n('Zahlung abschließen')}
            nextLink={{ go: onConfirm }}
            loading={loading}
          />
        </form>
      </div>
    );
  }
}

Summary.defaultProps = defaultProps;
Summary.propTypes = propTypes;

export default Summary;
